import { render, staticRenderFns } from "./makeDocment.vue?vue&type=template&id=ada5d638&scoped=true&"
import script from "./makeDocment.vue?vue&type=script&lang=js&"
export * from "./makeDocment.vue?vue&type=script&lang=js&"
import style0 from "./makeDocment.vue?vue&type=style&index=0&id=ada5d638&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ada5d638",
  null
  
)

export default component.exports